import { render, staticRenderFns } from "./ANxADxInfancyPage.vue?vue&type=template&id=2d616ba6"
import script from "./ANxADxInfancyPage.vue?vue&type=script&lang=js"
export * from "./ANxADxInfancyPage.vue?vue&type=script&lang=js"
import style0 from "./ANxADxInfancyPage.vue?vue&type=style&index=0&id=2d616ba6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports